<template>
  <div class="container">
    <TrfHeader pageTitle="Grupo de tarefas" />
    <div class="columns is-align-items-flex-end">
      <div class="column is-2-desktop is-12-mobile btn-container">
        <TrfButton
          v-if="!this.permissoesTarefas || this.permissoesTarefas?.Visualizar && this.permissoesTarefas.Criar || this.isSuperAdm"
          @click="this.openModal()"
          nome="Novo grupo"
          classCor="is-primary"
          :temIcon="true"
          classIcon="mdi-plus"
          class="is-fullwidth"
          id="btn-novo-grupo"
        />
      </div>
      <div class="column is-5-desktop is-12-mobile espaço-desktop"></div>
      <TrfInput
        class="column is-4-desktop is-fullwidth is-12-mobile"
        label="Nome"
        placeholder="Pesquise pelo nome do grupo"
        margin="0"
        height="5.3rem"
        :temIcon="true"
        classIcon="mdi-magnify"
        id="barraPesquisaGrupo"
        maxLength="100"
        v-model="this.nomeGrupo"
      />
      <div class="column is-1-desktop is-12-mobile">
        <TrfButton
          id="filtro-grupos-cadastrados"
          nome="Filtrar"
          class="is-fullwidth"
          classCor="is-primary"
          @click="this.filtrar(this.nomeGrupo)"
        />
      </div>
    </div>
    <TrfModalCadastroGrupo
      ref="modalCadastroEEdicao"
      :isModalActive="isModalActive"
      :titulo="tituloModal"
      :loadingProps="loading"
      :isModalEdicao="isModalEdicao"
      :listaTarefas="tarefas"
      :listaEmpresas="listaEmpresas"
      :listaGruposDeTarefa="gruposDeTarefasDto"
      :isGrupoPadraoProps="isGrupoPadrao"
      v-show="isModalActive"
      @close="closeModal"
      @ativaModalInclusaoTarefas="ativarModalInclusaoDeTarefas"
      @ativaModalEdicaoTarefas="ativarModalInclusaoDeTarefas"
      @ativarModalVigencia="abrirModalVigencia"
    />
    <TrfModal :isBtnLoading="btnLoading" :isModalActive="isModalInclusaoTarefas" @save="verificarModalAtivoESalva()" @close="verificarModalAtivoEFecha()" :btnSaveName="nomeBotoesSave" :btnCloseName="nomeBotoesClose" :titulo="tituloModalEdicaoTarefas">
      <div v-if="isModalSelecionarActive" class="conteudo-modal">
        {{ mensagemModalEdicaoTarefas }}
      </div>
      <div v-if="!isModalDataDeVigenciaActive && this.inseriuTarefas && this.removeuTarefas">
        <br>
        Deseja adicionar essa(s) tarefa(s) às empresas e deseja remover essa(s) tarefa(s) das empresas do {{ this.isGrupoPadrao ? "regime tributário" : "grupo"}} {{ this.objGrupoTarefas.nome }}?
      </div>
      <div v-if="isModalDataDeVigenciaActive">
        <div class="columns is-align-items-center">
          <div class="column is-two-thirds">
            {{ mensagemModalVigencia }}
          </div>
          <div class="column is-one-third is-align-items-baseline">
            <TrfInput
              type="date"
              placeholder="Data de Edição"
              id="data-edicao"
              v-model="dataDeVigencia"
              ref="dataDeVigencia"
            />
          </div>
        </div>
        <div v-if="mensagemDeAtencaoActive" v-html=mensagemAtencao>
        </div>
      </div>
    </TrfModal>

    <div class="pt-2">
      <TrfTabela
        :tipoTabela="'tabela-grupo'"
        :dataConfig="this.dataSource"
        :data="gruposDeTarefasDto"
        :quantidadeDeItems="this.total"
        :nextPage="this.nextPage"
        :nextLimit="this.nextLimit"
        :showDropdownOptions="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && (this.permissoesTarefas.Editar || this.permissoesTarefas.Excluir) || this.isSuperAdm ? true : false"
        :dataStatus="this.status"
        @update:pagina="(pagina) => this.atualizarPagina(pagina)"
        @update:limite="(limite) => this.atualizarLimite(limite)"
        :paginaSelecionada="this.pagina"
        :limiteAtual="this.limite"
        textoNadaEncontrado="Nenhuma tarefa foi encontrada."
        tituloExclusao="Excluir grupo de tarefas"
        :textoExclusao="textoExclusao"
        :showButtonsDefault="false"
        :showGlobalLoader ="this.showGlobalLoader"
        :showEdit = "!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
        :showDelete="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Excluir || this.isSuperAdm"
      />
    </div>
  </div>
</template>

<script>
import TrfHeader from "../../components/Header";
import TrfTabela from "../../components/Table";
import TrfInput from "../../components/Input";
import TrfButton from "../../components/Button";
import TrfModal from "../../components/Modal/index.vue";
import TrfModalCadastroGrupo from "../../components/Modal/TrfModalCadastroGrupo.vue";
import { service } from "./service/grupo-de-tarefas-service.js";
import { service as tarefasService } from "../CadastroTarefas/service/cadastro-tarefas-service.js"
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js";
import { toastUtils } from '../../util/toast.utils';
import { empresasService } from "../../service/empresas-service";
import { usuarioService } from "../../service/usuario-service";
import { acessoUtils } from "../../util/acesso.utils";
import DOMPurify from 'dompurify';

export default {
  name: "GrupoDeTarefas",
  components: {
    TrfHeader,
    TrfInput,
    TrfButton,
    TrfTabela,
    TrfModalCadastroGrupo,
    TrfModal
  },
  props: {
    statusTela: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isModalActive: false,
      dataSource: {
        columns: [
          {
            name: "nome",
            label: "Grupo",
            style: "width:91%",
          },
        ],
        selected: null,
        itens: [],
        select: (item) => {this.openModal(item)},
        preDelete: (item) => this.atribuirTextoExclusaoGrupoDeTarefas(item),
        delete: (item) => this.excluir(item),
      },
      status: this.statusTela,
      pagina: 1,
      total: 0,
      limite: 10,
      gruposDeTarefas: [],
      nomeGrupo: "",
      tituloModal: "",
      textoExclusao: "",
      loading: {
        modal: true,
        conteudo: false,
        campoTarefas: true,
        campoEmpresas: true
      },
      grupoDetarefa: {},
      tarefas: [],
      showGlobalLoader: false,
      permissoesTarefas: pessoaLogada.getPermissoes("Tarefas"),
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      isModalSelecionarActive: false,
      isModalDataDeVigenciaActive: false,
      isModalInclusaoTarefas: false,
      dataDeVigencia: "",
      btnLoading: false,
      objGrupoTarefas: {},
      listaEmpresas: [],
      isGrupoPadrao: false,
      inseriuTarefas: false,
      removeuTarefas: false,
      inseriuEmpresas: false,
      removeuEmpresas: false,
      tituloModalEdicaoTarefas: "",
      edicaoDeTarefasDesativada: false,
      isModalEdicao: false
    };
  },
  methods: {
    async openModal(item) {
      this.isModalActive = true;
      this.$refs.modalCadastroEEdicao.abrirTabCadastro();
      if(item && (!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar)) {
        this.loading.modal = true;
        this.isModalEdicao = true;
        this.tituloModal = "Editar grupo de tarefas";
        const grupoTarefaObject = Object.assign({},this.gruposDeTarefas.filter(grupo=>grupo.id === item.id)[0]);
        this.isGrupoPadrao = grupoTarefaObject.padrao;
        this.$refs.modalCadastroEEdicao.inicializarCamposNaEdicao(grupoTarefaObject);
        this.loading.modal = false;
      } else if (!this.permissoesTarefas || (this.permissoesTarefas.Visualizar && this.permissoesTarefas.Criar)) {
        this.isModalEdicao = false;
        this.tituloModal = "Cadastro de grupo de tarefas";
      }
    },
    closeModal() {
      this.isGrupoPadrao = false;
      this.dataVigencia = "";
      this.$refs.modalCadastroEEdicao.limparModal();
      this.isModalActive = false;
      this.loading.modal = true;
    },
    atribuirTextoExclusaoGrupoDeTarefas(grupo) {
      const nomeSanitizado = DOMPurify.sanitize(grupo.nome, { ALLOWED_TAGS: [] });
      this.textoExclusao = `Deseja excluir o grupo de tarefas <strong>${nomeSanitizado}</strong>?<br><br>
                            <strong>Atenção:</strong> Ao clicar em confirmar, as empresas vinculadas ao grupo não
                            serão removidas do vínculo da tarefa. `
    },
    async _carregarListagem() {
      this.showGlobalLoader = true;
      try {
        let listaDeGruposDeTarefas = "";

        if (this.nomeGrupo !== "") {
          return (listaDeGruposDeTarefas = this.filtrar(
            this.nomeGrupo,
            this.limite,
            this.pagina
          ));
        } else {
          listaDeGruposDeTarefas =
            await service.listarGrupoDeTarefasComPaginacao(
              this.limite,
              this.pagina
            );
        }
        this.total = parseInt(listaDeGruposDeTarefas.totalDeItens);

        if (this.total === 0) {
          this.status = "is-empty";
          this.gruposDeTarefas = [];
        } else {
          this.gruposDeTarefas = listaDeGruposDeTarefas.data;
          this.status = "";
        }
      } catch (e) {
        this.status = "is-danger";
      }
      this.showGlobalLoader = false;
    },

    async _listarTarefas() {
      this.loading.campoTarefas = true;
      const tarefasData = await this._adquirirTodasAsTarefas();
      this.tarefas = this._converterTarefasParaObjetoDoSelect(tarefasData);
      return this.tarefas;
    },

    async _adquirirTodasAsTarefas() {
      const objetoDeFiltro = {
        limit: 1,
        pagina: 1,
        "sort[DESC]": "ativo,id",
        "recorrencia[isnot]": null,
        ativo: true,
        parcelada: false
      }
      let limit = await tarefasService.listarTarefa(objetoDeFiltro);
      objetoDeFiltro.limit = limit.totalDeItens;

      const tarefas = await tarefasService.listarTarefa(objetoDeFiltro);
      return tarefas.data;
    },

    _converterTarefasParaObjetoDoSelect(tarefas) {
      if(!!!tarefas) return {};

      const objetoDoSelect = tarefas.map((tarefa) => {
        const option = {
          value: tarefa.id,
          label: tarefa.nome
        };
        return option;
      });

      return objetoDoSelect;
    },

    async nextPage(pagina) {
      this.pagina = pagina;

      this._carregarListagem();
    },
    async nextLimit(limite) {
      this.limite = limite;
      this._carregarListagem();
    },

    atualizarPagina(pagina) {
      this.pagina = pagina;
      this._carregarListagem();
    },

    atualizarLimite(limite) {
      this.limite = limite;
      this._carregarListagem();
    },

    async filtrar(nome) {
      this.status = "is-loading";
      this.gruposDeTarefas = [];
      try {
        this.showGlobalLoader = true;
        let listaDeGruposDeTarefas = await service.listarTarefaFiltro(
          nome,
          this.limite,
          this.pagina
        );

        this.total = parseInt(listaDeGruposDeTarefas.totalDeItens);

        if (this.total === 0) {
          this.status = "is-empty";
          this.gruposDeTarefas = []
        } else {
          this.gruposDeTarefas = listaDeGruposDeTarefas.data;
          this.status = "";
        }
        this.showGlobalLoader = false;
        return listaDeGruposDeTarefas;
      } catch (e) {
        this.status = "is-danger";
        this.showGlobalLoader = false;
      }
    },
    verificarModalAtivoESalva() {
      if (this.isModalSelecionarActive) {
        this.abrirModalVigencia();
      } else if (this.isModalDataDeVigenciaActive) {
        if(this.objGrupoTarefas.deveAlterarRecorrencias === undefined){
          this.objGrupoTarefas.deveAlterarRecorrencias = true;
        }
        if (this.isModalEdicao) {
          this.salvarEdicao();
        } else {
          this._cadastrarNovoGrupoDeTarefas();
        }
      }
    },
    verificarModalAtivoEFecha() {
      if (this.isModalSelecionarActive) {
        this.fecharModalInclusao();
      } else if (this.isModalDataDeVigenciaActive) {
        this.fecharModalDataVigencia();
      }
    },
    ativarModalInclusaoDeTarefas(grupoDeTarefas,inseriuTarefas,removeuTarefas,inseriuEmpresas,removeuEmpresas)  {
      this.objGrupoTarefas = grupoDeTarefas;
      this.inseriuTarefas = inseriuTarefas;
      this.removeuTarefas = removeuTarefas;
      this.inseriuEmpresas = inseriuEmpresas;
      this.removeuEmpresas = removeuEmpresas;

      this.getTituloModalEdicaoTarefas();
      this.isModalInclusaoTarefas = true;
      this.isModalSelecionarActive = true;
      this.isModalDataDeVigenciaActive = false;
      this.isModalActive = false;
      this.dataDeVigencia="";
      },
    abrirModalVigencia(grupoDeTarefas,inseriuTarefas,inseriuEmpresas,removeuEmpresas,isRemoveRecorrencias) {
      if (!!grupoDeTarefas) {
        this.objGrupoTarefas = grupoDeTarefas;
      }
      if (!!inseriuEmpresas) {
        this.inseriuEmpresas = inseriuEmpresas;
      }
      if (!!removeuEmpresas) {
        this.removeuEmpresas = removeuEmpresas;
      }
      if (!!inseriuTarefas) {
        this.inseriuTarefas = inseriuTarefas;
      }
      this.getTituloModalEdicaoTarefas(true);
      this.isModalInclusaoTarefas = true;
      this.isModalDataDeVigenciaActive = true;
      this.isModalSelecionarActive = false;
      this.isModalActive = false;
    },
    fecharModalDataVigencia() {
      this.$refs.dataDeVigencia.limparInput();
      this.dataDeVigencia = "";
      this.$refs.modalCadastroEEdicao.limparModal();
      this.btnLoading = false;
      this.isModalInclusaoTarefas = false;
      this.isModalDataDeVigenciaActive = false;
      this.isModalSelecionarActive = false;
      this.inseriuTarefas = false;
      this.inseriuEmpresas = false;
      this.removeuEmpresas = false;
    },
    fecharModalInclusao() {
      this.objGrupoTarefas.deveAlterarRecorrencias = false;
      if(this.inseriuEmpresas || this.removeuEmpresas){
        this.edicaoDeTarefasDesativada = true;
        this.abrirModalVigencia();
      }else{
        this.salvarEdicao();
      }



    },
    verificarSeHouveAlteracaoDeEmpresas() {
      return this.inseriuEmpresas || this.removeuEmpresas;
    },
    verificarSeHouveAlteracaoDeTarefas() {
      return this.inseriuTarefas || this.removeuTarefas;
    },
    async _cadastrarNovoGrupoDeTarefas() {
      try {
        this.btnLoading = true;
        this.objGrupoTarefas.dataVigencia = this.dataDeVigencia;
        await service.post(this.objGrupoTarefas);
        this.recarregarPaginaEDesativarLoader();
      } catch (e) {
        if(e.message){
          toastUtils.defaultToast(e.message,"is-danger", "center");
          this.btnLoading = false;
          return;
        }
        toastUtils.dangerToast("Ocorreu um erro ao cadastrar o grupo de tarefas. Favor cadastre novamente");
        this.btnLoading = false;
      }
    },
    async salvarEdicao() {
      this.btnLoading = true;
      await this.deveVincularEmpresasGrupoPadrao();
      this.objGrupoTarefas.empresasIds = Array.from(new Set(this.objGrupoTarefas.empresasIds));
      if (this.isModalDataDeVigenciaActive) {
        this.objGrupoTarefas.dataVigencia = this.dataDeVigencia;
        if (this.isGrupoPadrao) {
          this.objGrupoTarefas.isVinculaEmpresasGrupoPadrao = true;
        }
        if (this.$refs.dataDeVigencia?.verificarSeDataEValida()) {
          this.objGrupoTarefas.inseriuTarefas = this.inseriuTarefas;
          this.objGrupoTarefas.removeuTarefas = this.removeuTarefas;
          this.objGrupoTarefas.edicaoDeTarefasDesativada = this.edicaoDeTarefasDesativada;
          this.objGrupoTarefas.inseriuEmpresas = this.inseriuEmpresas;
          this.objGrupoTarefas.removeuEmpresas = this.removeuEmpresas;
          await service.editarGrupoDeTarefas(this.objGrupoTarefas);
          this.recarregarPaginaEDesativarLoader();
        } else {
          toastUtils.dangerToast('Data de inclusão inválida!');
          this.btnLoading = false;
        }
      } else {
        await service.editarGrupoDeTarefas(this.objGrupoTarefas,this.removeuTarefas);
        this.btnLoading = false;
      }
    },
    async deveVincularEmpresasGrupoPadrao() {
      if (!!this.dataDeVigencia && this.isGrupoPadrao) {
        this.objGrupoTarefas.isVinculaEmpresasGrupoPadrao = true;
      } else {
        this.objGrupoTarefas.isVinculaEmpresasGrupoPadrao = false;
      }
    },
    recarregarPaginaEDesativarLoader() {
      setTimeout(() => {
        window.location.reload(true);
        this.btnLoading = false;
      }, 1000);
    },
    async excluir(item) {
      let grupo = await service.buscarGrupoDeTarefas(item.id);

      try {
        if (grupo.padrao) {
          toastUtils.dangerToast(
            "Grupos de tarefas padrões não podem ser excluídos."
          );
          return;
        }
        await service.delete(grupo);
        toastUtils.successToast("Grupo de tarefas excluído com sucesso!");
        this._carregarListagem();
      } catch (error) {
        toastUtils.dangerToast("Erro ao tentar excluir o grupo!");
        console.error(error);
      }
    },
    async listarEmpresas() {
      this.loading.campoEmpresas = true;
      const filtros = {
        'filter[dataSaidaEscritorio]': empresasService.DATA_DE_SAIDA_PADRAO,
        'filter[legalizacaoEmAndamento]': false
      }
      let listaDeEmpresas = await empresasService.listarEmpresas(filtros);
      const responsavel = this.getResponsavelPorId();
      if (!responsavel.acessaTodasEmpresas && Array.isArray(responsavel.idsEmpresas)) {
        this.listaEmpresas = listaDeEmpresas.filter(empresa => responsavel.idsEmpresas.includes(empresa.value));
      } else {
        this.listaEmpresas = listaDeEmpresas;
      }
    },
    async getResponsavelPorId() {
      const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
      return await usuarioService.getResponsavel(responsavelLogadoUWD);
    },
    getTituloModalEdicaoTarefas(abreModalDeVigencia) {
      const possuiRemocaoDeTarefas = (this.inseriuTarefas && this.removeuTarefas) || (this.removeuTarefas);
      const alteracaoDeEmpresas = this.inseriuEmpresas || this.removeuEmpresas;

      if (abreModalDeVigencia && ((possuiRemocaoDeTarefas && alteracaoDeEmpresas) || alteracaoDeEmpresas)) {
        this.tituloModalEdicaoTarefas = 'Definição do período de vigência:';
        return;
      }

      if (this.inseriuTarefas && this.removeuTarefas && this.isModalEdicao) {
        this.tituloModalEdicaoTarefas = 'Inclusão/remoção de tarefas';
        return;
      }

      if (this.removeuTarefas) {
        this.tituloModalEdicaoTarefas = 'Remoção de tarefas';
        return;
      }

      this.tituloModalEdicaoTarefas = 'Inclusão de tarefas';
    }
  },
  async mounted() {
    await this._carregarListagem();
    await this._listarTarefas();
    await this.listarEmpresas();
  },
  computed: {
    nomeBotoesSave() {
      if (this.isModalSelecionarActive) {
        return 'Sim';
      } else {
        return 'Confirmar'
      }
    },
    nomeBotoesClose() {
      if (this.isModalSelecionarActive) {
        return 'Não';
      } else {
        return 'Cancelar';
      }
    },
    mensagemModalVigencia() {

      if (!this.isModalEdicao) {
        return "Informe a data de início de controle da(s) tarefa(s) para a(s) empresa(s) vinculada(s) ao grupo:";
      }

      if (((!this.edicaoDeTarefas || this.edicaoDeTarefasDesativada) && this.removeuEmpresas)) {
        return "Informe a data de remoção de controle da(s) tarefa(s) para a(s) empresa(s) removida(s) do grupo:";
      }

      if (((!this.edicaoDeTarefas || this.edicaoDeTarefasDesativada) && this.inseriuEmpresas)) {
        return "Informe a data de início de controle da(s) tarefa(s) para a(s) nova(s) empresa(s) adicionada(s) ao grupo:";
      }

      if (this.inseriuTarefas && this.removeuTarefas && this.isModalEdicao) {
        return "Informe a data de inclusão/remoção das tarefas nas empresas:";
      }

      if (this.removeuTarefas) {
        return "Informe a data de remoção das tarefas nas empresas:";
      }

      return "Selecione a data de inclusão das tarefas nas empresas:";
    },
    gruposDeTarefasDto() {
      const listaDeGruposDeTarefasDto = [];

      this?.gruposDeTarefas?.forEach((tarefa) => {
        let gruposDto = {
          id: tarefa.id,
          nome: tarefa.nome,
        };
        listaDeGruposDeTarefasDto.push(gruposDto);
      });
      return listaDeGruposDeTarefasDto;
    },
    mensagemAtencao() {

      if (!this.edicaoDeTarefasDesativada  && this.inseriuTarefas && this.removeuTarefas) {
        return `<strong>Atenção:</strong> Ao clicar em confirmar, para as tarefas removidas do grupo, não serão mais criadas recorrências dessa tarefa para as empresas.`;
      }

      if (!this.edicaoDeTarefasDesativada  && this.removeuTarefas) {
        return `<strong>Atenção:</strong> Ao clicar em confirmar não serão mais criadas recorrências dessa tarefa para as empresas.`;
      }

      return `<strong>Atenção:</strong> Ao clicar em salvar não serão mais criadas recorrências destas tarefas para a(s) empresa(s) removida(s).`;
    },
    mensagemModalEdicaoTarefas() {
      const mensagem = this.isGrupoPadrao ? "regime tributário" : "grupo";
      let acao;

      if (this.isModalEdicao && this.inseriuTarefas && this.removeuTarefas) {
        return `Identificamos que houve uma inclusão e uma remoção de tarefas ao grupo.`;
      }

      if (this.inseriuTarefas) {
        acao = "adicionar";
      }

      if (this.removeuTarefas) {
        acao = "remover";
      }

      return `Deseja ${acao} essa(s) tarefa(s) das empresas vinculadas ao ${mensagem} ${this.objGrupoTarefas.nome}?`;
    },
    mensagemDeAtencaoActive() {
      const edicaoGeralDeEmpresas = this.inseriuEmpresas || this.removeuEmpresas;
      const possuiRemocaoDeTarefasConfirmada = this.possuiRemocaoDeTarefas &&  !this.edicaoDeTarefasDesativada;
      return possuiRemocaoDeTarefasConfirmada
            || (edicaoGeralDeEmpresas && possuiRemocaoDeTarefasConfirmada)
            || ((!this.edicaoDeTarefas || this.edicaoDeTarefasDesativada) && this.removeuEmpresas);
    },
    possuiRemocaoDeTarefas() {
      return ((this.inseriuTarefas && this.removeuTarefas) || (this.removeuTarefas));
    },
    edicaoDeTarefas() {
      return this.inseriuTarefas || this.removeuTarefas;
    }
  }
};
</script>

<style lang="scss" scoped>
.espaço-desktop {
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.btn-container {
  @media screen and (max-width: 600px) {
    margin-right: 0;
  }

  @media screen and (min-width: 900px) {
    width: 150px;
    margin-right: auto;
  }
}

</style>
